import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import React, { useEffect, useMemo } from 'react';

interface Props {
  jobBoardId: number;
  advertId: number;
  attributes?: Record<string, string>;
  attributeChangeHandler?: (jobBoardId: number, key: string, value: string) => void;
}

export default function BalanceRecruitmentWebsiteEdit({
  jobBoardId,
  attributes,
  attributeChangeHandler,
}: Props) {
  const atts = useMemo<Record<string, string>>(() => {
    if (attributes) return attributes;
    return {};
  }, [attributes]);

  const classification = useMemo(() => atts.classification ?? '', [atts.classification]);
  const subClassification = useMemo(() => atts.subClassification ?? '', [atts.subClassification]);
  const country = useMemo(() => atts.country ?? '', [atts.country]);
  const region = useMemo(() => atts.region ?? '', [atts.region]);
  const location = useMemo(() => atts.location ?? '', [atts.location]);
  const workType = useMemo(() => atts.workType ?? '', [atts.workType]);
  const salaryType = useMemo(() => atts.salaryType ?? '', [atts.salaryType]);
  const salaryFrom = useMemo(() => atts.salaryFrom ?? '', [atts.salaryFrom]);
  const salaryTo = useMemo(() => atts.salaryTo ?? '', [atts.salaryTo]);
  const displaySalary = useMemo(() => atts.displaySalary ?? '', [atts.displaySalary]);

  useEffect(
    () =>
      attributeChangeHandler &&
      attributeChangeHandler(jobBoardId, 'classification', classification),
    [attributeChangeHandler, classification, jobBoardId]
  );
  useEffect(
    () =>
      attributeChangeHandler &&
      attributeChangeHandler(jobBoardId, 'subClassification', subClassification),
    [attributeChangeHandler, subClassification, jobBoardId]
  );
  useEffect(
    () => attributeChangeHandler && attributeChangeHandler(jobBoardId, 'country', country),
    [attributeChangeHandler, country, jobBoardId]
  );
  useEffect(
    () => attributeChangeHandler && attributeChangeHandler(jobBoardId, 'region', region),
    [attributeChangeHandler, region, jobBoardId]
  );
  useEffect(
    () => attributeChangeHandler && attributeChangeHandler(jobBoardId, 'location', location),
    [attributeChangeHandler, location, jobBoardId]
  );
  useEffect(
    () => attributeChangeHandler && attributeChangeHandler(jobBoardId, 'workType', workType),
    [attributeChangeHandler, workType, jobBoardId]
  );
  useEffect(
    () => attributeChangeHandler && attributeChangeHandler(jobBoardId, 'salaryType', salaryType),
    [attributeChangeHandler, salaryType, jobBoardId]
  );
  useEffect(
    () => attributeChangeHandler && attributeChangeHandler(jobBoardId, 'salaryFrom', salaryFrom),
    [attributeChangeHandler, salaryFrom, jobBoardId]
  );
  useEffect(
    () => attributeChangeHandler && attributeChangeHandler(jobBoardId, 'salaryTo', salaryTo),
    [attributeChangeHandler, salaryTo, jobBoardId]
  );
  useEffect(
    () =>
      attributeChangeHandler && attributeChangeHandler(jobBoardId, 'displaySalary', displaySalary),
    [attributeChangeHandler, displaySalary, jobBoardId]
  );

  return (
    <Box display="flex" gap={2} pt={2}>
      <Box display="flex" flexDirection="column" gap={2} width="50%">
        <TextField disabled label="Classification" value={classification} />
        <TextField disabled label="Sub-Classification" value={subClassification} />
        <TextField disabled label="Country" value={country} />
        <TextField disabled label="Region" value={region} />
        <TextField disabled label="Location" value={location} />
      </Box>
      <Box display="flex" flexDirection="column" gap={2} width="50%">
        <TextField disabled label="Work Type" value={workType} />
        <TextField disabled label="Salary Type" value={salaryType} />
        <Box display="flex" gap={2}>
          <TextField disabled label="Salary From" sx={{ flex: '1 1 0' }} value={salaryFrom} />
          <TextField disabled label="Salary To" sx={{ flex: '1 1 0' }} value={salaryTo} />
        </Box>
        <TextField disabled label="Display Salary" value={displaySalary} />
      </Box>
    </Box>
  );
}
